// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"50d875d2","453":"a6fe97ca","591":"b6461a82"}[chunkId] + ".chunk.js";
};